export enum ButtonColor {
  Red = 'Red',
  Yellow = 'Yellow',
  NavyBlue = 'NavyBlue',
  DarkBlue = 'DarkBlue',
  LightBlue = 'LightBlue',
  BabyBlue = 'BabyBlue',
  White = 'White',
  WhiteBordered = 'WhiteBordered',
  Transparent = 'Transparent',
  TransparentBordered = 'TransparentBordered',
  Grey = 'Grey',
  GreyBordered = 'GreyBordered',
  Purple = 'Purple'
}

export enum ButtonType {
  Info = 'Info',
  Action = 'Action',
  Icon = 'Icon'
}
